module.exports = __webpack_public_path__ + "static/media/Pegasus.d7825185.png";